var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M17.9381 10.6102C17.9381 12.5745 16.3596 14.162 14.4133 14.162H3.52484C1.57856 14.162 0 12.5745 0 10.6102C0 8.84334 1.28258 7.38138 2.96876 7.11231C2.94186 6.98674 2.93289 6.86118 2.93289 6.72664C2.93289 5.48891 3.92845 4.4754 5.16619 4.4754C5.7133 4.4754 6.22454 4.68169 6.61021 5.01355C7.30082 3.44396 8.18876 1.99994 10.6822 1.99994C13.7047 1.99994 15.1308 4.34984 15.1308 6.83427C15.1308 6.93293 15.1308 7.04056 15.1219 7.13922C15.9186 7.30615 16.6336 7.74238 17.1465 8.37453C17.6594 9.00668 17.939 9.79619 17.9381 10.6102Z",
    fill: "#B58FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8743 2.45973L16.1427 3.72815L10.4348 9.43603L7.72813 12.1427L4.20727 8.20724L5.78005 6.93603L7.9789 9.43603L14.8743 2.45973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectEmail);
export default __webpack_public_path__ + "static/media/connect-email.f4e11d59454a306134c73044596aad47.svg";
export { ForwardRef as ReactComponent };